// import actions
import fichaAction from './actions/ficha'
import detalleAction from './actions/detalle'

// import getters
import fichaGetter from './getters/ficha'
import detalleGetter from './getters/detalle'

// import mutations
import fichaMutation from './mutations/ficha'
import detalleMutation from './mutations/detalle'

// import states
import fichaState from './states/ficha'
import detalleState from './states/detalle'

const actions = {
  ...fichaAction,
  ...detalleAction,
}

const getters = {
  ...fichaGetter,
  ...detalleGetter,
}

const mutations = {
  ...fichaMutation,
  ...detalleMutation,
}

const state = {
  ...fichaState,
  ...detalleState,
}

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
}
